const ADDRESS_SEARCH_REGEX = /^(?![-\s])([A-Za-z0-9'.\-\s,]+)$/;

export const isValidAddressSearch = (value: string): boolean => ADDRESS_SEARCH_REGEX.test(value);
